export const SignupStatus = {
    CREATED: 0,
    EXPIRED: 2,
    SIGNED_UP: 10,
    PAYABLE: 14,
    PAID: 20,
    TRANSFERRED: 24,
    REFUNDING: 26,
    REFUNDED: 30,
    CANCELLED: 40,

    getKey(value) {
        return Object.keys(this).find(key => this[key] === value) || 'UNKNOWN';
    },
    
    getValue(key) {
        return this[key] || this.CREATED;
    },

    getIndex(status) {
        return Object.values(this).indexOf(status);
    }
}; 